<template>
  <div :class="[isbg && 'sdkdow_btn']">
    <single-button @know="download" :text="text" :width="width" :height="height" ></single-button>
  </div>
</template>

<script>
import  store from '@/store';
export default {
  name: 'VueNew39SdkdowBtn',

  props: {
    text: {
      type: String,
      default: '立即下载'
    },
    url: {
      type: String,
      default: ''
    },
    isbg:{
      type: Boolean,
      default: true
    },
    width:{
      type: String,
      default: '11.7rem'
    },
    height:{
      type: String,
      default: '2rem'
    },
  },

  computed: {
    advertisingId() {
      return localStorage.getItem('advertisingId')
    },
    game_id() {
      return localStorage.getItem('sdkgame_id')
    },
    isIOS() {
      return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    },
    isAndroid() {
      return /(Android)/i.test(navigator.userAgent);
    },
    isPc(){
      return /(Windows)/i.test(navigator.userAgent);
    }
  },

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    download(type,data) {
      const sdkPageActive = store.state.community.sdkPageActive;
      console.log('下载',sdkPageActive);
      var bundelId = ''
      if(this.isIOS){
        bundelId = 'com.sjbox.ios'
      } else if(this.isAndroid){
        bundelId = 'com.sjbox.az'
      }

      var sdkstartUrl = ''
      if(sdkPageActive && location.href.indexOf('/pages/sdkpage/index') != -1){
        switch (sdkPageActive) {
          case 1:
            sdkstartUrl = `${bundelId}://communityData=/pages/index/gift/gift?id=${this.game_id}`
            break;
          case 2:
            sdkstartUrl = `${bundelId}://communityData=/pages/index/gamedetail/gamedetail?id=${this.game_id}`
            break;
          case 3:
            sdkstartUrl = `${bundelId}://communityData=/pages/community/community?id=${this.game_id}&sdktype=1`
            break;
          case 4:
            sdkstartUrl = `${bundelId}://communityData=/pages/yun/yun`
            break;
          case 5:
            sdkstartUrl = `${bundelId}://communityData=/pages/community/community?id=${this.game_id}`
            break;
        }
      } else {
        const data = location.pathname + location.search
        sdkstartUrl =  `${bundelId}://communityData=${data}`
      }
      switch (type) {
        case 'giftDetail':
          sdkstartUrl = `${bundelId}://communityData=/pages/index/gift/giftDetail?id=${data}`
          break;
      }
      // location.href = sdkstartUrl
      window.parent.postMessage({ event: 'openBox', download_url: '',  bundle_id: bundelId, startUrl: sdkstartUrl }, '*')
      console.log('startUrl',{ event: 'openBox', download_url: '',  bundle_id: bundelId, startUrl: sdkstartUrl });
      // 判断不是iframe环境
      if (window.self == window.top) {
        if(!this.isPc) location.href = sdkstartUrl
      }

      this.$ajax('/common/sdkDownloadApp', {
        advertisingId: this.advertisingId,
        gameId: this.game_id
      })
      
      if(type == 'open') return
      this.$downPopup('down') 
    }
  },
};
</script>

<style lang="scss" scoped>
.sdkdow_btn{
  width: 100%;
  height: 3rem;
  background: rgba(255,255,255,.8);
  display: flex;
  justify-content: center;
  align-items: center;    
  position: fixed;
  bottom: 0;
  z-index: 1000;
  pointer-events: auto;
  max-width: 523px;
}
</style>